module.exports = __webpack_public_path__ + "img/store-home.60f0742c.png";